import { render, staticRenderFns } from "./PrikaziObrazec.vue?vue&type=template&id=fa036a54&"
import script from "./PrikaziObrazec.vue?vue&type=script&lang=js&"
export * from "./PrikaziObrazec.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports